// import axios from "axios";
// import { GET_REPORT_DATA } from "../../../utils/api";
// import { REPORT_DATA_FAILURE, REPORT_DATA_SUCCESS } from "./report.actionTypes";

// export const reportData = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_REPORT_DATA, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: REPORT_DATA_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: REPORT_DATA_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: REPORT_DATA_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };


import { apiRequest } from "../../../api/apiRequest";
import { GET_REPORT_DATA } from "../../../utils/api";
import { REPORT_DATA_FAILURE, REPORT_DATA_SUCCESS } from "./report.actionTypes";

export const reportData = () => async (dispatch) => {
  const result = await apiRequest("get", GET_REPORT_DATA);

  if (result.success) {
    dispatch({
      type: REPORT_DATA_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: REPORT_DATA_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};